import { defineRecipe as r } from "@pandacss/dev";
import { iconButtonRecipe as a } from "@huspy/briks-core";
const t = r({
  className: "icon-button",
  base: { ...a.base, minWidth: "auto!" },
  defaultVariants: {
    variant: "primary",
    size: "md"
  },
  variants: {
    size: { ...a.size, sm: { ...a.size.sm } },
    variant: a.variant,
    disabled: { true: {} }
  },
  compoundVariants: [
    {
      variant: "primary",
      css: {
        _hover: a.hover.primary,
        _active: a.active.primary
      }
    },
    {
      variant: "secondary",
      css: {
        _hover: a.hover.secondary,
        _active: a.active.secondary
      }
    },
    {
      variant: "tertiary",
      css: {
        _hover: a.hover.tertiary,
        _active: a.active.tertiary
      }
    },
    {
      variant: "primary",
      disabled: !0,
      css: {
        ...a.disabled.primary,
        _hover: {
          ...a.disabled.primary
        },
        _active: {
          ...a.disabled.primary
        }
      }
    },
    {
      variant: "secondary",
      disabled: !0,
      css: {
        ...a.disabled.secondary,
        _hover: {
          ...a.disabled.secondary
        },
        _active: {
          ...a.disabled.secondary
        }
      }
    },
    {
      variant: "tertiary",
      disabled: !0,
      css: {
        ...a.disabled.tertiary,
        _hover: {
          ...a.disabled.tertiary
        },
        _active: {
          ...a.disabled.tertiary
        }
      }
    }
  ]
});
export {
  t as iconButton
};
